import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LanguageStorageService } from '../language/languageStorage.service';
import { environment } from '../../environments/environment';



@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor(private languageStorage: LanguageStorageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const lang = this.languageStorage.getLanguage() || 'en';

    const apiBase = (environment as any).api.url;

    // If lang is already in URL, skip and ..
    // Only modify if request goes to your server
    if (!req.url.startsWith(apiBase) || req.url.includes('lang=')) {
      return next.handle(req);
    }

    const separator = req.url.includes('?') ? '&' : '?';
    const modifiedReq = req.clone({
      // url: `${req.url}${separator}lang=${lang}`
      url: `${req.url}`
    });

    return next.handle(modifiedReq);
  }
}
